import React from "react";
import { PhoneIcon } from "lucide-react";
import { firm } from "../../data/site";
import { CaseReviewForm } from "../form/CaseReviewForm";
type CaseReviewSectionProps = {
  showReviewNotes: boolean;
};
export function CaseReviewSection({
  showReviewNotes
}: CaseReviewSectionProps) {
  return <section id="case-review" aria-labelledby="case-review-title" className="border-t border-line bg-ivory" data-id="element-147" data-mp="32j5q7t27ypgs">
      <div className="page-container grid gap-10 py-16 md:py-24 lg:grid-cols-12 lg:gap-16" data-id="element-148" data-mp="3q904mf26sm35">
        <div className="lg:col-span-5" data-id="element-149" data-mp="3v8mdydew9i6o">
          <h2 id="case-review-title" className="text-h2-m font-extrabold text-ink md:text-h2" data-id="element-150" data-mp="3v7jng6lhhhra">
            Free case review
          </h2>
          <p className="mt-5 max-w-measure text-slate" data-id="element-151" data-mp="3li9ygzlxsf7e">
            Motorcycle injury and death cases only. Use the form, or call the firm.
          </p>
          <div className="mt-8 border-t border-line pt-6" data-id="element-152" data-mp="d159w8r4n9tf">
            <p className="text-meta font-semibold text-slate" data-id="element-153" data-mp="htq3paa19mwy">Prefer to talk?</p>
            <a href={firm.phoneHref} className="mt-2 inline-flex min-h-[48px] items-center gap-3 text-phone font-extrabold text-ink hover:text-crimson" data-id="element-154" data-mp="3odt0gge9pvec">
              <PhoneIcon aria-hidden="true" className="h-7 w-7 text-crimson" data-id="element-155" data-mp="10yts2he8x0x" />
              {firm.phoneDisplay}
            </a>
            <p className="mt-1 text-meta text-slate" data-id="element-156" data-mp="3sfe6piwarbfk">{firm.phoneDigits}</p>
          </div>
        </div>
        <div className="lg:col-span-7" data-id="element-157" data-mp="ay3f603f0ogo">
          <CaseReviewForm showReviewNotes={showReviewNotes} data-id="element-158" data-mp="b195tjrozyei" />
        </div>
      </div>
    </section>;
}